import { memo, useCallback } from "react";
import "./top-listing-headers.css";
import SearchFilterInput from "../../form-fields/search-filter-input";
import SimpleButton from "../../buttons/Simple-button";
import H2 from "../../typography/H2";
import SortIcon from "../../../assets/svgs/SortIcon";
import SingleDropdown from "../../singleDropdown/SingleDropdown";
import Chevren_downIcon from "../../../assets/svgs/Chevren_down";

interface ListingTopHeaderProps {
  PageHeading?: string;
  Count?: number;
  ButtonName?: string;
  MobileButtonName?: string;
  searchTerm: string;
  setSearchTerm: (term: string) => void;
  onClick?: () => void;
  handleSort: (sortDirection: "asc" | "desc") => void;
  currentSortDirection: "asc" | "desc";
  // New Filter Props
  activeFilter: string;
  handleFilterChange: (filter: string) => void;
  aggregateValuesFilters?: Record<string, number>;
  showAddButton?: boolean;
}

function ContractorTopHeader({
  PageHeading,
  Count,
  ButtonName,
  MobileButtonName,
  searchTerm,
  setSearchTerm,
  onClick,
  handleSort,
  currentSortDirection,
  activeFilter,
  handleFilterChange,
  aggregateValuesFilters,
  showAddButton = true,
}: ListingTopHeaderProps) {

  const sortDirectionText = currentSortDirection === "asc" ? "A-Z" : "Z-A";

  const handleSearch = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(e.target.value);
  }, [setSearchTerm]);

  const handleSortChange = useCallback(() => {
    const newDirection = currentSortDirection === "asc" ? "desc" : "asc";
    handleSort(newDirection);
  }, [currentSortDirection, handleSort]);

  return (
    <div className="top-listing-headers">
      <div className="top-listing-header-main contractor-header">
        <div className="top-listing-header-left">
          <H2 text={`${PageHeading}`} />
          {ButtonName && showAddButton && (
            <div className="top-listing-header-button-mobile">
              <SimpleButton label={MobileButtonName || ButtonName} onClick={onClick} />
            </div>
          )}
        </div>
        <div className="top-listing-header-right">
          <div className="search-sort-container" style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
            <SearchFilterInput
              placeholder="Search By Contractor Name"
              searchTerm={searchTerm}
              handleSearch={handleSearch}
            />

            <div className="filters-mobile">
              <SingleDropdown
                triggerText={activeFilter || "All"}
                triggerIcon={<Chevren_downIcon width={"18"} height={"18"} />}
                triggerIconPosition="right"
                menuItems={aggregateValuesFilters ? Object.entries(aggregateValuesFilters).map(([title, count]) => ({
                  label: `${title} (${count})`,
                  action: () => handleFilterChange(title),
                })) : []}
              />
            </div>

            <div className="sort-button" onClick={handleSortChange} role="button" tabIndex={0}>
              <span className="sort-text">Sort by: {sortDirectionText}</span>
              <SortIcon />
            </div>
          </div>
          {ButtonName && showAddButton && (
            <div className="top-listing-header-button-desktop">
              <SimpleButton label={ButtonName} onClick={onClick} />
            </div>
          )}
        </div>
      </div>

      <div className="top-listing-header-filters" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '1rem', marginBottom: '1rem' }}>
        <div className="filter-options filters-desktop" style={{ gap: '10px' }}>
          {aggregateValuesFilters && Object.entries(aggregateValuesFilters).map(([title, count]) => (
            <button
              key={title}
              className={`filter-option ${activeFilter === title ? "filter-option-active" : ""}`}
              onClick={() => handleFilterChange(title)}
            >
              {title} ({count})
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
export default memo(ContractorTopHeader);